import React, { useRef } from "react";
import * as Yup from "yup";
import classNames from "classnames";
import newsLang from "../../i18n/news";
import {
  EnvelopeFill,
  PersonFill,
  TelephoneFill,
  FilePersonFill,
} from "react-bootstrap-icons";
import { Field, Form, Formik } from "formik";
import Cookies from "js-cookie";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import useBeforeunload from "hooks/useBeforeunload";
import { postRequest } from "actions/requests";
import { toast, ToastContainer } from "react-toastify";

const ReceiveNewsForm = ({
  locale,
  vertical,
  name,
  email,
  phone,
  position,
  btnClasses,
  onSubmit,
}) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [setIsUnload] = useBeforeunload();
  const refValue = useRef({ email: "", name: "", position: "", phone: "" });

  const handleSubmit = async (values, actions) => {
    const token = await executeRecaptcha("contact");
    values.lang_id = locale === "vi" ? 1 : 2;
    if (values.phone === "") values.phone = undefined;
    if (values.position === "") values.position = undefined;
    values.type = 3;
    if (token) {
      let msg = locale === "vi" ? "Đăng ký thành công" : "Register success";
      postRequest(values)
        .then((res) => {
          toast.success(msg, {
            position: "top-center",
            autoClose: 3000,
            closeOnClick: true,
            pauseOnHover: true,
            newestOnTop: true,
          });
          actions.resetForm({
            values: { email: "", name: "", position: "", phone: "" },
          });
          if (onClick) {
            onClick();
          } else {
            setTimeout(() => {
              push("/news");
            }, 2000);
          }
          setIsUnload(false);
          Cookies.remove("isLeave");
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  };

  const handleChangeValues = (e) => {
    const values = e.target.value;
    const name = e.target.name;
    Cookies.set("isLeave", true);
    setIsUnload(true);
    if (values) {
      refValue.current = { ...refValue.current, [name]: values };
      Cookies.set(name, values, { expires: 30 * 12 * 5 });
    }
  };

  const handleBlur = (e) => {
    const values = e.target.defaultValue;
    const name = e.target.name;

    if (!values) {
      Cookies.set(
        { ...refValue.current, [name]: refValue.current[name] },
        { expires: 30 * 12 * 5 }
      );
    }
  };
  return (
    <>
      <ToastContainer />
      <Formik
        onSubmit={onSubmit ? onSubmit : handleSubmit}
        validationSchema={Yup.object().shape({
          name: Yup.string().trim().required(
            locale === "vi" ? "Trường bắt buộc" : "Required field"
          ),
          email: Yup.string().trim()
            .email(
              locale === "vi" ? "Không đúng định dạng email" : "Invalid email"
            )
            .required(locale === "vi" ? "Trường bắt buộc" : "Required field"),
        })}
        initialValues={{
          name: Cookies.get("name") || undefined,
          email: Cookies.get("email") || undefined,
          phone: Cookies.get("phone") || undefined,
          position: Cookies.get("position") || undefined,
        }}
        enableReinitialize={true}
      >
        {({ values, submitForm, errors, touched }) => (
          <>
            <div
              className={classNames(
                "col-md-8 col-lg-9",
                vertical && "col-lg-12 col-md-12 mb-4"
              )}
            >
              <Form onBlur={handleBlur} onChange={handleChangeValues}>
                <div className="row">
                  {name && (
                    <div className={classNames(vertical ? "col-12" : "col-6")}>
                      <div className="position-relative mb-3">
                        <span
                          className="position-absolute"
                          style={{ top: "5px", left: "15px" }}
                        >
                          <PersonFill
                            className="sm-text-size"
                            style={{ color: "#707070" }}
                          />
                        </span>
                        <Field
                          name="name"
                          style={{
                            height: "38px",
                            border: "1px solid #b6b6b6",
                          }}
                          className="w-100 py-1 pr-3 pl-5"
                          placeholder={newsLang.formRegister.inputName[locale]}
                        />
                        {errors.name && touched.name ? (
                          <div className="error-text">{errors.name}</div>
                        ) : null}
                      </div>
                    </div>
                  )}
                  {position && (
                    <div className={classNames(vertical ? "col-12" : "col-6")}>
                      <div className="position-relative mb-3">
                        <span
                          className="position-absolute"
                          style={{ top: "5px", left: "15px" }}
                        >
                          <FilePersonFill
                            className="sm-text-size"
                            style={{ color: "#707070" }}
                          />
                        </span>
                        <Field
                          name="position"
                          style={{
                            height: "38px",
                            border: "1px solid #b6b6b6",
                          }}
                          className="w-100 py-1 pr-3 pl-5"
                          placeholder={
                            newsLang.formRegister.inputPosition[locale]
                          }
                        />
                      </div>
                    </div>
                  )}
                  {phone && (
                    <div className={classNames(vertical ? "col-12" : "col-6")}>
                      <div className="position-relative mb-3">
                        <span
                          className="position-absolute"
                          style={{ top: "5px", left: "15px" }}
                        >
                          <TelephoneFill
                            className="sm-text-size"
                            style={{ color: "#707070" }}
                          />
                        </span>
                        <Field
                          name="phone"
                          style={{
                            height: "38px",
                            border: "1px solid #b6b6b6",
                          }}
                          className="w-100 py-1 pr-3 pl-5"
                          placeholder={newsLang.formRegister.inputPhone[locale]}
                        />
                      </div>
                    </div>
                  )}
                  {email && (
                    <div className={classNames(vertical ? "col-12" : "col-6")}>
                      <div className="position-relative">
                        <span
                          className="position-absolute"
                          style={{ top: "5px", left: "15px" }}
                        >
                          <EnvelopeFill
                            className="sm-text-size"
                            style={{ color: "#707070" }}
                          />
                        </span>
                        <Field
                          name="email"
                          style={{
                            height: "38px",
                            border: "1px solid #b6b6b6",
                          }}
                          className="w-100 py-1 pr-3 pl-5"
                          placeholder={newsLang.formRegister.inputEmail[locale]}
                        />
                        {errors.email && touched.email ? (
                          <div className="error-text">{errors.email}</div>
                        ) : null}
                      </div>
                    </div>
                  )}
                </div>
              </Form>
            </div>
            <div
              className={classNames(
                "col-md-4 col-lg-3",
                vertical && "col-lg-12 col-md-12"
              )}
            >
              <button
                type="button"
                onClick={() => submitForm()}
                className={classNames(
                  "btn btn-primary btn-block text-uppercase",
                  btnClasses
                )}
              >
                {newsLang.formRegister.labelButton[locale]}
              </button>
            </div>
          </>
        )}
      </Formik>
    </>
  );
};

export default ReceiveNewsForm;
